import { render } from "./DresscodesList.vue?vue&type=template&id=05df6584"
import script from "./DresscodesList.vue?vue&type=script&lang=js"
export * from "./DresscodesList.vue?vue&type=script&lang=js"

import "./DresscodesList.vue?vue&type=style&index=0&id=05df6584&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__